import { Suspense } from 'react';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';
import { DownloadsPage } from './page/DownloadsPage.tsx';

export function DownloadsRoot() {
  return (
    <Titled title={() => page('Downloads')}>
      <Suspense fallback={<LoadingSpinner />}>
        <DownloadsPage />
      </Suspense>
    </Titled>
  );
}
